// extracted by mini-css-extract-plugin
export var columnList = "_a2-0";